import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { CombinedTextProps } from '@dtx-company/shared-components/src'
import { StyledLinkText, StyledText } from './AuthForm.styles'
import React from 'react'

interface FormToggleCTAProps extends Pick<CombinedTextProps, 'fontWeight' | 'textDecoration'> {
  isSignUp: boolean
  onClick: () => void
  invertColor?: boolean
}

export const FormToggleCTA: React.FC<FormToggleCTAProps> = ({
  isSignUp,
  onClick,
  fontWeight = 'bold',
  textDecoration = 'none',
  invertColor
}) => (
  <Box justifyContent="center">
    <StyledText fontWeight={fontWeight} invertColor={invertColor}>
      {isSignUp ? 'Already have an account?' : "Don't have an account?"}&nbsp;
    </StyledText>
    <StyledLinkText
      onClick={() => {
        onClick()
      }}
      color="primary.flowBlue"
      cursor="pointer"
      fontWeight="bold"
      textDecoration={textDecoration}
      invertColor={invertColor}
      data-testid={isSignUp ? 'sign-in' : 'sign-up'}
    >
      {isSignUp ? 'Sign in' : 'Sign up'}
    </StyledLinkText>
  </Box>
)
